export function formatarConfiguracoesAvancadas (state) {
  const modalidadeDeBancoEhGeral = state.modalidadeDoBanco.selected.id === 'geral'

  if (!modalidadeDeBancoEhGeral) {
    return {
      gatilhoLimiteGeral: null,
      gatilhoBaseMensal: null,
      apontamentosDesconsideradosGatilhoMensal: []
    }
  }

  return {
    gatilhoLimiteGeral: state.usarGatilhoDeSaldoGeral ? state.gatilhoLimiteGeral : null,
    gatilhoBaseMensal: state.usarGatilhoDeSaldoMensal ? state.gatilhoBaseMensal : null,
    apontamentosDesconsideradosGatilhoMensal: state.camposDesconsideradosDoGatilhoMensal.map(campo => campo.id)
  }
}
